module.exports = __webpack_public_path__ + "static/img/home_cpjfw_hwaqapp.0df76c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_hwaqapp.png
// module id = baQm
// module chunks = 21